import React from 'react'
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import StudentRegistraion from "./StudentRegistration"
import ScholarShipNotification from "../../assets/URL_PDFs/Scholarship_notification.pdf"
// import "./Iqac.css";


const Scholarship = () => {
    const [value, setValue] = React.useState("1");
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <div>

            <Box sx={{ width: "100%", typography: "body1", textAlign: "center" }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                            centered
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                        >
                            <Tab
                                sx={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                    color: "rgb(37, 31, 31)",
                                }}
                                label="Student ScholarShip Registration"
                                value="1"
                            />
                            <Tab
                                sx={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                    color: "rgb(37, 31, 31)",
                                }}
                                label="Student ScholarShip Information"
                                value="2"
                            />





                        </TabList>
                    </Box>
                    <TabPanel value="1">

                        <StudentRegistraion />

                    </TabPanel>
                    <TabPanel value="2">

                          <iframe
                                      src={ScholarShipNotification}
                                      width="60%"
                                      height="600px"
                                      title="ScholarShipNotification"
                                      style={{ border: "none" }}
                                    />   


                    </TabPanel>


                </TabContext>
            </Box>

        </div>
    )
}

export default Scholarship
